import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import {
  MatButtonModule,
  MatIconModule,
  MatMenuModule,
  MatProgressBarModule,
  MatToolbarModule,
  MatSlideToggleModule,
} from "@angular/material";

import { TranslateModule } from "@ngx-translate/core";

import { FuseSharedModule } from "@fuse/shared.module";

import { FuseToolbarComponent } from "app/main/toolbar/toolbar.component";
import { FuseConfirmDialogModule, FuseShortcutsModule } from "@fuse/components";

@NgModule({
  declarations: [FuseToolbarComponent],
  imports: [
    RouterModule,
    TranslateModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatProgressBarModule,
    MatToolbarModule,
    MatSlideToggleModule,

    FuseSharedModule,
    FuseShortcutsModule,
    FuseConfirmDialogModule,
  ],
  exports: [FuseToolbarComponent],
})
export class FuseToolbarModule {}



// WEBPACK FOOTER //
// ./src/app/main/toolbar/toolbar.module.ts